import { produce } from 'immer';
import { entity } from 'simpler-state';

import configLib from '../../configLib';

const INITIAL_STATE = {
  currentStatus: 'unknown' as AppStateStatus,
};
export type AppStateStatus = 'active' | 'background' | 'inactive' | 'unknown' | 'extension'
export type AppStateCacheData = typeof INITIAL_STATE;

const options = {
  storage: configLib.storage as any,
  serializeFn: JSON.stringify,
  deserializeFn: JSON.parse,
};
const self = entity(INITIAL_STATE);

function setCurrentAppStatus(value: AppStateStatus) {
  self.set(produce(state => {
    state.currentStatus = value;
  }));
}

export default {
  useCurrentAppStatus: () => self.use(data => data.currentStatus),
  getCurrentAppStatus: () => self.get().currentStatus,
  setCurrentAppStatus,
};
